var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-row" },
    [
      _c(
        "div",
        { staticClass: "item-tit" },
        [
          _vm._v(" " + _vm._s(_vm.title || _vm.$t(_vm.titleI18n)) + " "),
          _vm.isValidator && _vm.useRequired ? _c("required") : _vm._e()
        ],
        1
      ),
      _c(
        "vuelidate-form",
        {
          attrs: {
            validator: _vm.isValidator ? _vm.$v.value : null,
            "validator-params": _vm.errMsgParam,
            messages: _vm.errMsg
          }
        },
        [
          _c("div", { staticClass: "item-desc" }, [
            _c(
              "div",
              {
                class: ["form-check-group", _vm.isHorizontal ? "--type1" : ""]
              },
              [
                _vm._l(_vm.dataList, function(data, i) {
                  return [
                    _c("div", { key: i, staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkedValueData,
                            expression: "checkedValueData"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: _vm.id,
                          id: _vm.id + "-" + i
                        },
                        domProps: {
                          value: data.value,
                          checked: _vm._q(_vm.checkedValueData, data.value)
                        },
                        on: {
                          change: function($event) {
                            _vm.checkedValueData = data.value
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: _vm.id + "-" + i }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.i18nUse ? _vm.$t(data.text) : data.text)
                          )
                        ]
                      )
                    ])
                  ]
                })
              ],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }